import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyScrollspyContainer = () => {
  return <PropertyDetail type="scrollspy" />;
};

export default PropertyScrollspyContainer;
